import InboxClassificationFilterHashtag from '../store/schema/InboxClassificationFilterHashtag';
import { isInboxPlusEnabled } from './inboxPlusFlightUtil';
import InboxClassificationFilter from '../store/schema/InboxClassificationFilter';

export default function getHashtagsToInclude(
    inboxClassificationFilter: InboxClassificationFilter
): InboxClassificationFilterHashtag[] {
    if (!isInboxPlusEnabled()) {
        return null;
    }

    switch (inboxClassificationFilter) {
        case InboxClassificationFilter.Newsletters:
            return ['#NewslettersPlus'];
        case InboxClassificationFilter.Promotions:
            return ['#Promotions'];
        case InboxClassificationFilter.Social:
            return ['#Social'];
        default:
            return [];
    }
}
